import React from 'react'
import styled from '@emotion/styled'
import css from '@emotion/css'
import { Link } from 'gatsby'
import { Hidden, Card } from '@material-ui/core'
import IssueCard from './IssueCard'
import { getEmSize } from '../../../styles/mixins'
import { widths, colors, breakpoints } from '../../../styles/variables'
import StyledBackgroundSection from './StyledBackgroundSection'
import JoinUsForm from '../Hero/JoinUsForm'
import JoinTheMovement from './JoinTheMovement'
import MobilePhoto from './MobilePhoto'

const Container = styled.div`
  display: flex;
  height: 800px;
  width: 100%;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    height: auto;
    flex-direction: column;
  }
`

const Title = styled.h2`
  font-size: 50px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  text-align: center;
  color: ${colors.white};
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    text-align: left;
  }
`

const InnerContainer = styled(Card)`
  height: 90%;
  width: 560px;
  margin-left: 10%;
  background-color: ${colors.darkBlue};
  padding-left: 60px;
  padding-right: 60px;
  border-radius: 5px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    height: auto;
    width: 100%;
    margin: 0;
    border-radius: 0;
    padding-left: 20px;
    padding-right: 20px;
  }
`

interface Props {
  joined?: boolean
}

function Join({ joined = false }: Props) {
  return (
    <Container id="thanks-for-joining">
      <Hidden smDown>
        <StyledBackgroundSection>
          <InnerContainer>
            <Title>{joined ? 'Together we can win. Thank you.' : 'Join the Movement'}</Title>
            {!joined && <JoinTheMovement />}
          </InnerContainer>
        </StyledBackgroundSection>
      </Hidden>
      <Hidden mdUp>
        <MobilePhoto style={{ height: '500px', width: '100%' }} imgStyle={{ height: '500px', width: '100%' }} objectPosition="80% 50%" />
        <InnerContainer>
          <Title>{joined ? 'Together we can win. Thank you.' : 'Join the Movement'}</Title>
          {!joined && <JoinTheMovement />}
        </InnerContainer>
      </Hidden>
    </Container>
  )
}

export default Join
